import { render } from "./car.vue?vue&type=template&id=105c9048&scoped=true"
import script from "./car.vue?vue&type=script&lang=js"
export * from "./car.vue?vue&type=script&lang=js"

import "./car.vue?vue&type=style&index=0&id=105c9048&lang=scss&scoped=true"

import exportComponent from "E:\\projects\\resturant2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105c9048"]])

export default __exports__